import React from 'react'
import { useDroppable } from '@dnd-kit/core'
import clsx from 'clsx'

interface KanbanColumnProps {
  id: string
  title: string
  taskCount: number
  children: React.ReactNode
}

export const KanbanColumn: React.FC<KanbanColumnProps> = ({ id, title, taskCount, children }) => {
  const { setNodeRef, isOver } = useDroppable({
    id,
  })
  const isCollapsed = taskCount === 0 && !isOver

  return (
    <div
      ref={setNodeRef}
      className={clsx(
        'rounded-xl border-2 bg-stone-200 transition-all duration-200',
        isCollapsed ? 'min-h-[600px] w-16 min-w-[4rem] px-2 py-4' : 'min-h-[600px] min-w-[360px] p-4',
        isOver ? 'border-slate-600 bg-stone-100' : 'border-stone-300'
      )}
    >
      {isCollapsed ? (
        <div className="flex h-full flex-col items-center justify-between gap-4">
          <div className="rounded-full border border-stone-400 bg-stone-100 px-2 py-1 text-[10px] font-semibold text-slate-600">
            0
          </div>
          <div
            className="text-center text-sm font-semibold tracking-wide text-slate-900"
            style={{ writingMode: 'vertical-rl', textOrientation: 'mixed', transform: 'rotate(180deg)' }}
          >
            {title}
          </div>
          <div className="text-[10px] uppercase tracking-[0.2em] text-slate-500">Drop</div>
        </div>
      ) : (
        <>
          <div className="mb-4 flex items-center justify-between">
            <div>
              <h3 className="font-semibold text-slate-900">{title}</h3>
              <p className="text-xs text-slate-600">{taskCount} task{taskCount === 1 ? '' : 's'}</p>
            </div>
          </div>
          <div className="space-y-3">{children}</div>
        </>
      )}
    </div>
  )
}

export default KanbanColumn
